import { render, staticRenderFns } from "./CapNhatGroup.vue?vue&type=template&id=6d185388&"
import script from "./CapNhatGroup.vue?vue&type=script&lang=js&"
export * from "./CapNhatGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports